module.exports = __webpack_public_path__ + "media/assets/img/authot_studio_draw-e77be8563b46f997100252e2de8315d8.png";